import { gql } from '@apollo/client'

export default gql`
  mutation CreateRoninMarketPlaceOrder($input: RoninMarketPlaceOrderInput!) {
    createRoninMarketPlaceOrder(input: $input)
  }
`
